<template>
  <div id="app">
    <Headers></Headers>
    <div class="center">
      <div class="h1">
        <div class="w">
          <div class="li-1">
            <img src="../assets/img/aboutUs/h1-1.png" alt="" />
          </div>
          <img class="li-2" src="../assets/img/aboutUs/h1-2.png" alt="" />
          <!-- <img src="../assets/img/aboutUs/h1-3.png" alt=""> -->
          <p>
            北京天相财富管理顾问有限公司（简称“天相财富”）是天相投资顾问有限公司的全资子公司，2015年10月26
            日成立，具有中国证监会核准的证券投资咨询业务资格(业务许可证编号：91110102MA001GJE1N)。股多多产品是天相财富具有全部知识产权的面向广大投资者的证券投资辅助决策工具软件。
          </p>
        </div>
        <div class="h1-2">
          <div class="w">
            <div class="lis1"><a href="#zizhi">查看营业执照 ></a></div>
            <div class="lis2">
              <a href="#zizhi">查看证券期货业务经营许可证 > </a>
            </div>
            <div class="lis3">
              <a href="#zizhi">查看计算机软件著作权登记证书 > </a>
            </div>
          </div>
        </div>
      </div>
      <div class="h2">
        <div class="w">
          <div class="li-1">
            <img src="../assets/img/aboutUs/h2-1.png" alt="" />
          </div>
          <div class="li-2">
            基于对我国改革开放和证券市场长期发展前景的坚定信念，天相投身于证券事业，参与我国证券市场的成长过程。天相始终秉承诚恳、诚信、勤勉、专业的价值观，与投资者建立长期、温暖合作关系，成为中国证券市场投资者信赖的投资伙伴。
          </div>
          <div class="li-3">
            <div class="lis">
              <img src="../assets/img/aboutUs/h2-2.png" alt="" />
              <p>理清投资管理目标</p>
            </div>
            <div class="lis">
              <img src="../assets/img/aboutUs/h2-2.png" alt="" />
              <p>捕捉市场价值洼地</p>
            </div>
            <div class="lis">
              <img src="../assets/img/aboutUs/h2-2.png" alt="" />
              <p>研判行业潜在价值</p>
            </div>
            <div class="lis">
              <img src="../assets/img/aboutUs/h2-2.png" alt="" />
              <p>升级智能辅助决策平台</p>
            </div>
          </div>
        </div>
      </div>
      <div class="h3">
        <div class="w">
          <div class="li-1">
            <img src="../assets/img/aboutUs/h3-2.png" alt="" />
          </div>
          <div class="li-2">
            <div class="lis1">
              <div class="liss1">
                <img src="../assets/img/aboutUs/h3-3.png" alt="" />
              </div>
              <div class="text1">权限审核</div>
              <div class="text2">
                开通：按流程为客户激活产品权限；严格执行证券投资咨询业务相关法规；负责审查客户签署的合同资料的有效性、真实性、合规性。
              </div>
            </div>
            <div class="lis1">
              <div class="liss1">
                <img src="../assets/img/aboutUs/h3-4.png" alt="" />
              </div>
              <div class="text1">质量检查</div>
              <div class="text2">
                质检：根据业内的合规政策要求，制定相关监管制度，约束员工的行为规范，协助与业务相关的部门共同推进公司的决策，以保证公司合规合法经营。
              </div>
            </div>
            <div class="lis1">
              <div class="liss1">
                <img src="../assets/img/aboutUs/h3-5.png" alt="" />
              </div>
              <div class="text1">风控管理</div>
              <div class="text2">
                风控：通过风险评估，采取措施减小风险事件发生的可能性，把可能的损失控制在一定的范围内以避免在风险事件发生时带来的难以承担的损失。
              </div>
            </div>
          </div>
          <div class="li-3">
            <div class="lis">
              <div class="liss">
                <div class="liss1">
                  <div class="text1">公司</div>
                  <div class="textplus">总公司</div>
                  <div class="text3 text33">上海分公司</div>
                  <div class="text4 text33">山东分公司</div>
                  <div class="text4 text33">河北分公司</div>
                  <div class="text4 text33">青岛分公司</div>
                  <div class="text4 text33">杭州分公司</div>
                </div>
                <div class="liss2">
                  <div class="text1">姓 名</div>
                  <div class="text2">林 征</div>
                  <div class="text2">王 昕</div>
                  <div class="text2">潘惠君</div>
                  <!-- <div class="text2">吴保军</div> -->

                  <!-- <div class="text2">朱永魁</div> -->
                  <div class="text3">胡 奎</div>
                  <div class="text4">张大堃</div>
                  <div class="text4">胡彬彬</div>
                  <div class="text4">侯 彪</div>
                  <div class="text4">丁爱清</div>
                </div>
                <div class="liss3">
                  <div class="text1">职 务</div>
                  <div class="text2">执行董事</div>
                  <div class="text2">总经理</div>
                   <div class="text2">财务负责人</div>
                  <!-- <div class="text2">副总经理</div> -->

                  <!-- <div class="text2">监事</div> -->
                  <div class="text3">负责人</div>
                  <div class="text4">负责人</div>
                  <div class="text4">负责人</div>
                  <div class="text4">负责人</div>
                  <div class="text4">负责人</div>
                </div>
                <div class="liss4">
                  <div class="text1">执业登记编号</div>
                  <div class="text2">A1320617040002</div>
                  <div class="text2">A1320519120001</div>
                  <div class="text2">/</div>
                  <!-- <div class="text2">/</div> -->

                  <!-- <div class="text2">/</div> -->
                  <div class="text3">A1320625070010</div>
                  <div class="text4">A1320121020008</div>
                  <div class="text4">A1320121120011</div>
                  <div class="text4">A1320122080071</div>
                  <div class="text4">A1320124040023</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="h5">
        <div class="w">
          <div class="li-1">
            <img src="../assets/img/aboutUs/h5-1.png" alt="" />
          </div>
          <div class="container">
            <div class="company-card">
              <h2>天相财富总公司(德胜园办公区)</h2>
              <p><span class="detail-label">公司地址:</span> 北京市西城区新街口外大街 28 号 C 座五层502</p>
              <p><span class="detail-label">总部投诉电话:</span> 010-66045777</p>
            </div>

            <div class="company-card">
              <h2>天相财富总公司(汉威办公区)</h2>
              <p><span class="detail-label">公司地址:</span> 北京市丰台区南四环西路186号三区4号楼2层09-10室，3号楼2层01、05-06室</p>
              <p><span class="detail-label">客服电话:</span> 010-66045051<span class="detail-label">&nbsp;&nbsp;&nbsp;&nbsp;投诉电话:</span> 400-101-8662</p>
            </div>
            <div class="company-card">
              <h2>上海分公司</h2>
              <p><span class="detail-label">公司地址:</span> 上海市浦东新区福山路33号建工大厦23B、23C、20C、20D、9A、9D</p>
              <p><span class="detail-label">客服&投诉电话:</span> 021-68911708</p>
            </div>
            <div class="company-card">
              <h2>山东分公司</h2>
              <p><span class="detail-label">公司地址:</span> 山东省济南市高新区舜泰广场2号楼2802D</p>
              <p><span class="detail-label">客服&投诉电话:</span> 0531-88162317</p>
            </div>
            <div class="company-card">
              <h2>河北分公司</h2>
              <p><span class="detail-label">公司地址:</span> 河北省石家庄市桥西区友谊南大街106号中环商务大厦18楼</p>
              <p><span class="detail-label">客服&投诉电话:</span> 0311-67900628</p>
            </div>
            <div class="company-card">
              <h2>青岛分公司</h2>
              <p><span class="detail-label">公司地址:</span> 青岛市黄岛区长江中路485号国汇金融中心A座23层</p>
              <p><span class="detail-label">客服&投诉电话:</span> 0532-86993980</p>
            </div>
            <div class="company-card">
              <h2>杭州分公司</h2>
              <p><span class="detail-label">公司地址:</span> 浙江省杭州市滨江区西兴街道阡陌路459号C楼C2-805室</p>
              <p><span class="detail-label">联系电话:</span> 13501954866</p>
            </div>
          </div>


          <!-- <div class="li-2">
            <div class="text1">北京天相财富管理顾问有限公司</div>
            <div class="text2">公司邮箱： <span>shouhou@txsec.com</span></div>
            <div class="text2">客服电话：010-66045050</div>
            <div class="text2">申诉电话：400-101-8662</div>
            <div class="text2">公司网址：https://www.txcfgl.com</div>
            <div class="text2">公司地址：北京丰台区汉威国际广场3-5-10M</div>
          </div> -->
        </div>
      </div>
      <div class="h4" id="h4">
        <div class="w">
          <div class="li-1" id="zizhi">
            <img src="../assets/img/aboutUs/h4-1.png" alt="" />
          </div>
          <div class="li-2">
            <img class="lis2" src="../assets/img/aboutUs/xk.jpg" @click="bigImg('xk.jpg')" alt="" />
            <img class="lis1" src="../assets/img/aboutUs/rz.jpg" @click="bigImg('rz.jpg')" alt="" />
            <img class="lis3" src="../assets/img/aboutUs/zz.jpg" @click="bigImg('zz.jpg')" alt="" />
          </div>
        </div>
      </div>

      <div class="mc" v-if="imgOff" @click="closeImg()">
        <img :src="require('@/assets/img/aboutUs/' + img)" style="
            z-index: 999999;
            position: absolute;
            width: 50%;
            height: 50;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
          " alt="" />
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>
<script>
import Headers from "../components/headers";
import Bottom from "../components/bottom";
export default {
  name: "aboutUs",
  components: {
    Headers,
    Bottom
  },
  data() {
    return {
      imgOff: false,
      phone: ""
    };
  },
  methods: {
    closeImg() {
      this.imgOff = false;
    },
    bigImg(val) {
      this.imgOff = true;
      this.img = val;
    }
  }
};
</script>

<style lang="less" scoped>
.mc {
  position: fixed;
  align-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}

.h1 {
  width: 100%;
  height: 584px;
  background: url(../assets/img/aboutUs/h1.png);
  background-size: 100% 100%;

  .w {
    width: 1200px;
    height: 498px;
    margin: 0 auto;

    .li-1 {
      padding-top: 113px;
      margin-bottom: 13px;
      border: #000000 1px;
    }

    .li-2 {
      margin-bottom: 19px;
    }

    // p{
    //   font-size: 32px;
    // }
  }

  .h1-2 {
    width: 100%;
    height: 86px;
    background: url(../assets/img/aboutUs/h1-4.png);
    background-size: 100% 100%;

    .w {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #f9c589;
      }

      .lis1 {
        width: 246px;
        height: 86px;
        background-color: #850c0b;
        text-align: center;
        line-height: 86px;
      }
    }
  }
}

.h2 {
  width: 100%;
  height: 335px;
  background: url(../assets/img/aboutUs/h2.png);
  background-size: 100% 100%;

  .w {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .li-1 {
      padding-top: 40px;
      margin-bottom: 36px;
    }

    .li-2 {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #3a3737;
      line-height: 29px;
      margin-bottom: 60px;
    }

    .li-3 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .lis {
        display: flex;
        align-items: center;

        img {
          margin-right: 14px;
        }
      }
    }
  }
}

.h3 {
  width: 100%;
  height: 1510px;
  background: url(../assets/img/aboutUs/h3.png);
  background-size: 100% 100%;

  .w {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .li-1 {
      padding-top: 45px;
      margin-bottom: 40px;
    }

    .li-2 {
      margin-bottom: 30px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .lis1 {
        width: 372px;
        height: 462px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;

        .liss1 {
          padding-top: 20px;
        }

        .text1 {
          margin-top: 30px;
          margin-bottom: 22px;
          font-size: 39px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #a21118;
        }

        .text2 {
          width: 325px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
        }
      }
    }

    .li-3 {
      width: 1200px;
      height: 854px;
      background: url(../assets/img/aboutUs/h3-6.png);
      background-size: 100% 100%;

      .lis {
        padding-top: 132px;
      }

      .liss {
        width: 1129px;
        height: 525px;
        margin: 0 auto;
        border: 1px solid #898886;
        display: flex;

        .text1 {
          height: 72px;
          line-height: 72px;
          text-align: center;
          border-bottom: 1px solid #898886;
          width: 100%;
          font-size: 28px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #a3171e;
        }

        .textplus {
          width: 100%;
          height: 152px;
          line-height: 152px;
          text-align: center;
          font-size: 28px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #373737;
          border-bottom: 1px solid #898886;
        }

        .text2 {
          width: 100%;
          height: 50px;
          line-height: 52px;
          text-align: center;
          font-size: 28px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #252525;
          border-bottom: 1px solid #898886;
        }

        .text3 {
          font-size: 28px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          width: 100%;
          height: 59px;
          line-height: 59px;
          text-align: center;
          border-bottom: 1px solid #898886;

        }

        .text4 {
          height: 59px;
          width: 100%;
          text-align: center;
          line-height: 59px;
          border-bottom: 1px solid #898886;
          font-size: 28px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
        }

        .text33 {
          font-size: 28px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #373737;
        }

        .liss1 {
          width: 266px;
          height: 100%;
          border-right: 1px solid #898886;
        }

        .liss2 {
          width: 208px;
          height: 100%;
          border-right: 1px solid #898886;
        }

        .liss3 {
          width: 230px;
          height: 100%;
          border-right: 1px solid #898886;
        }

        .liss4 {
          width: 422px;
          height: 100%;
        }
      }
    }
  }
}

.h4 {
  height: 483px;
  width: 100%;
  background: url(../assets/img/aboutUs/h4.png);
  background-size: 100% 100%;

  .w {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .li-1 {
      padding-top: 32px;
      margin-bottom: 63px;
    }

    .li-2 {
      width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .lis1 {
        height: 300px;
        // border-radius: 1px  solid  #333;
      }

      .lis2 {
        height: 300px;
        // border-radius: 1px  solid  #333;
      }

      .lis3 {
        height: 300px;
        // border-radius: 1px  solid  #333;
      }

      // .lis {
      //   width: 379px;
      //   height: 293px;
      //   background: url(../assets/img/aboutUs/h4-2.png) no-repeat;
      //   background-size: 100% 100%;
      //   background-position: center;
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      //   margin-bottom: 32px;
      // }
    }
  }
}

.h5 {
  width: 100%;
  height: 634px;

  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .li-1 {
      padding-top: 42px;
      margin-bottom: 56px;
    }

    .li-2 {
      width: 1200px;
      height: 460px;
      background: url(../assets/img/aboutUs/h5-2.png);
      background-size: 100% 100%;

      .text1 {
        font-size: 35px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        padding-top: 97px;
        padding-left: 31px;
        margin-bottom: 45px;
      }

      .text2 {
        padding-left: 36px;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;

        span {
          color: #2489df;
        }
      }
    }
  }
}
 .container {
   width: 1200px;
   height: 498px;
   display: grid;
   grid-template-columns: repeat(auto-fit, minmax(500px, 1fr)); /* 修正为auto-fit */
   grid-gap: 20px;
   overflow: hidden;
 }

 .company-card {
   background-color: #f9f9f9;
   padding: 20px;
   border-radius: 5px;
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
   // margin-bottom: 20px;
   overflow: visible;
   word-wrap: break-word;
   word-break: break-all;
 }

 .company-card h2 {
   margin-top: 0;
   margin-bottom: 10px;
 }

 .company-card p {
   margin: 0;
   line-height: 1.6;
   white-space: normal;
 }

 .detail-label {
   font-weight: bold;
   margin-right: 5px;
 }
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs.vue